import styled from 'styled-components'

export const StyledFeaturedBlock = {
  Title: styled.h2`
    margin-bottom: 20px;
    font-weight: 700;
    font-size: 24px;
    line-height: 30px;
    color: #4e5160;
    text-align: center;
  `,
}
